import { Helmet } from "react-helmet";
import { useLoaderData, useNavigate } from "react-router-dom";

import { get } from "api";
import { RepeatMDFooter } from "atoms/repeatmd-footer/RepeatMDFooter";
import { ProductCardLarge } from "molecules/cards/product-card-large/ProductCardLarge";
import TopNav from "molecules/navbars/TopNav";
import { queryClient } from "pages/Root";
import { hasLinearPricing } from "services/ListingHelperService";
import { waitObj } from "toolbox/Promise";
import { defineLoader } from "toolbox/Router";

type LoaderData = Awaited<ReturnType<typeof publicShopLoader>>;

export const publicShopLoader = defineLoader(async () => {
  const listings = queryClient.fetchQuery(
    ["/listings/public"],
    () => get("/listings/public"),
    { staleTime: 1000 * 60 }
  );

  const platform = queryClient.fetchQuery(
    ["/platform/current"],
    () => get("/platform/current").catch(() => null),
    { staleTime: 1000 * 60 }
  );

  return waitObj({ listings, platform });
});

const ShopTreatmentsPage = () => {
  const { listings, platform } = useLoaderData() as LoaderData;
  const navigate = useNavigate();
  const treatments = listings.filter((listing) => listing.type === "Treatment");

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <TopNav>
        <img
          className="h-8"
          src={platform?.logoImageUrl ?? ""}
          alt="Platform Logo"
        />
      </TopNav>
      <div className="flex flex-col bg-two">
        {treatments.map((listing) => (
          <ProductCardLarge
            key={listing.id}
            title={listing.title}
            description={listing.description}
            imageUrl={listing.imageUrl}
            type={listing.type}
            tag={""}
            onClick={() => {
              navigate("/signin");
            }}
            price={listing.baseCost}
            memberPrice={listing.membershipCost}
            unitType={listing.packageUnitType?.singularUnitType}
            hasLinearPricing={hasLinearPricing(
              listing.packages?.flatMap((p) => p.packagePrices)
            )}
            guestMode={false}
          />
        ))}
        <RepeatMDFooter showLinks />
      </div>
    </>
  );
};

export default ShopTreatmentsPage;
